// extracted by mini-css-extract-plugin
export default {"carousel__overlay_title":"Carousel_carousel__overlay_title__+sgLs","carousel__overlay_subtitle":"Carousel_carousel__overlay_subtitle__5bHBa"};